import invariant from 'ts-tiny-invariant';
export function isDefined(value) {
    return value !== undefined && value !== null;
}
export function assertDefined(value, message) {
    invariant(isDefined(value), message);
}
//# sourceMappingURL=index.js.map